import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UpdateVehicleTemplate, VehicleTemplate } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createVehicleTemplateApi, vehicleTemplateKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UpdateVehicleTemplateVariables {
  data: UpdateVehicleTemplate;
  id: string;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUpdateVehicleTemplate(): UseMutationResult<VehicleTemplate, Error, UpdateVehicleTemplateVariables> {
  const client = useApiClient('admin-auth');
  const api = createVehicleTemplateApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<VehicleTemplate, Error, UpdateVehicleTemplateVariables>({
    mutationFn: ({ data, id }: UpdateVehicleTemplateVariables) => api.updateVehicleTemplate(id, data),
    ...createMutationCallbacks({
      errorKey: 'vehicleTemplates.toast.updateError',
      invalidateKeys: [vehicleTemplateKeys.all],
      queryClient,
      successKey: 'vehicleTemplates.toast.updateSuccess',
      t,
    }),
  });
}
